/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/Phones/Content/Phone/Number/Description/Content"
  
}) {
let constantData = '('
let phoneDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'phone',
path: 'description',
})
let constantData1 = ')'
let aggregateData = fromAggregate.joinNoSpace(constantData, phoneDescriptionValueData, constantData1)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="'('"
 data="phone.description"
 data="')'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}